/* eslint-disable import/prefer-default-export */
export const permissionDeniedErrorCatcher = (error) => error && error.message === 'You do not have permission to perform this action';
